module.exports = __webpack_public_path__ + "assets/spoleczenstwo.8ac8caac.svg";